import { render, staticRenderFns } from "./ExclusiveCard.vue?vue&type=template&id=5bbc8962&scoped=true&"
import script from "./ExclusiveCard.vue?vue&type=script&lang=js&"
export * from "./ExclusiveCard.vue?vue&type=script&lang=js&"
import style0 from "./ExclusiveCard.vue?vue&type=style&index=0&id=5bbc8962&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbc8962",
  null
  
)

export default component.exports